import { Sprout } from "lucide-react";

/**
 * Small sage-green badge that flags volunteer guests visually so other
 * residents + admins can spot them at a glance. Renders nothing when
 * `show` is falsy so it can be sprinkled anywhere with a single prop.
 *
 * Variants:
 *   "pill"  — full text "VOLUNTEER" badge (default, for cards/lists)
 *   "dot"   — tiny icon-only chip (for tight spaces like tables/avatars)
 */
const VolunteerBadge = ({ show = false, variant = "pill", className = "" }) => {
  // Treat any falsy value (false / undefined / null / 0) as "not a volunteer".
  // Important: this avoids showing the badge on every guest when the backend
  // hasn't populated `is_volunteer` on a particular endpoint's response.
  if (!show) return null;

  if (variant === "dot") {
    return (
      <span
        className={`inline-flex items-center justify-center w-4 h-4 rounded-full bg-[#8C9A7C] text-white ${className}`}
        title="Team Member"
        data-testid="volunteer-badge-dot"
      >
        <Sprout className="w-2.5 h-2.5" />
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-wider bg-[#8C9A7C]/20 text-[#5C6A4C] px-1.5 py-0.5 rounded-full font-semibold flex-shrink-0 ${className}`}
      title="Team Member at Savi"
      data-testid="volunteer-badge"
    >
      <Sprout className="w-2.5 h-2.5" />
      Team
    </span>
  );
};

export default VolunteerBadge;
